import React, { lazy } from 'react';
import { unstable_HistoryRouter as HistoryRouter, Route, Routes, Navigate } from 'react-router-dom';
import { createBrowserHistory } from 'history';

const ParkIndustrialDataPage = lazy(() => import('src/pages/park_industrial_data'));
const LoginPage = lazy(() => import('src/pages/login'));

function AppRouter(props) {
    const browserHistory = createBrowserHistory({
        basename: `${window.envConfig.baseRouter}`
    });

    // 路由监听
    browserHistory.listen(({ location, action }) => {

    });

    return (
        <HistoryRouter history={browserHistory} basename={`${window.envConfig.baseRouter}`}>
            <Routes>
                <Route path="/" element={<Navigate to="/login" />} />
                <Route exact path="/login" element={<LoginPage />} />
                <Route  path="/parkindustrialdata" element={<ParkIndustrialDataPage />} />
            </Routes>
        </HistoryRouter>
    );
}

export default AppRouter;
